import React from 'react';
import './Pricing.css';
import { useNavigate } from 'react-router-dom';
import { pricingProducts } from '../../data/agents';

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-container">
        <header className="pricing-header">
          <h2 className="pricing-title">Tools for the Future</h2>
          <p className="pricing-subtitle">Select the modules you need to power your ecosystem.</p>
        </header>

        <div className="pricing-grid">
          {pricingProducts.map((product) => (
            <div
              key={product.id}
              className="pricing-card"
              onClick={() => navigate(`/agent/${product.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="product-icon">
                {product.icon}
              </div>
              <h3 className="product-name">{product.name}</h3>
              <p className="product-description">{product.description}</p>

              <div className="product-footer">
                <div className="product-price">
                  <span className="amount">{product.price}</span>
                  <span className="period">{product.period}</span>
                </div>
                <button
                  className="pricing-cta-button"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent double navigation
                    navigate(`/agent/${product.id}`);
                  }}
                >
                  Get Access
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="pricing-footer-cta">
          <button 
            className="view-all-products-btn"
            onClick={() => navigate('/agents')}
          >
            Explore Agents
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '8px' }}>
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
